import React from 'react'
import InfoMessage, { InfoMessageContent } from '../InfoMessage'
import { ReactComponent as CommentsIcon } from '@sketch/icons/comments-64'
import AddAnnotationButton from '../AddAnnotationButton'
// eslint-disable-next-line no-restricted-imports
import { AnnotationStatusFilter } from '@sketch/gql-types/expansive'

interface CommentTabMessageNoAnnotationsProps {
  action?: React.ReactNode
  showAddCommentButton?: boolean
  annotationStatus?: AnnotationStatusFilter
}

const emptyAnnotationsTitle: Record<AnnotationStatusFilter, string> = {
  ACTIVE_ONLY: 'No open comments',
  RESOLVED_ONLY: 'No resolved comments',
  ALL: 'No comments yet',
}

const CommentTabMessageNoAnnotations: React.FC<CommentTabMessageNoAnnotationsProps> = ({
  action,
  showAddCommentButton,
  annotationStatus,
}) => {
  return (
    <InfoMessage
      title={emptyAnnotationsTitle[annotationStatus || 'ALL']}
      action={action}
      icon={<CommentsIcon role="img" />}
    >
      <InfoMessageContent>
        {showAddCommentButton && (
          <AddAnnotationButton>Add New Comment</AddAnnotationButton>
        )}
      </InfoMessageContent>
    </InfoMessage>
  )
}

export default CommentTabMessageNoAnnotations
